import { useEffect } from "react";

export interface ToastState {
  message: string;
  kind: "info" | "success" | "error";
}

interface ToastProps {
  toast: ToastState | null;
  onDismiss: () => void;
}

export function Toast({ toast, onDismiss }: ToastProps) {
  useEffect(() => {
    if (!toast) return;
    const timeout = window.setTimeout(onDismiss, toast.kind === "error" ? 6000 : 3500);
    return () => window.clearTimeout(timeout);
  }, [toast, onDismiss]);

  if (!toast) return null;

  return (
    <div className={`toast toast-${toast.kind}`} role="status" onClick={onDismiss}>
      {toast.message}
    </div>
  );
}
